import type { I18nFn } from 'i18n/types/I18nFn';
import { I18N_LOCALES } from 'i18n/types/I18nLocale';
import type { SearchFacetData } from 'modules/search/types/SearchFacetData';
import { LOCALE_NAMES } from 'utils/constants/general/locales';

export const localeFacet = (i18n: I18nFn) =>
  ({
    id: 'localeFacet',
    name: 'locale',
    get title() {
      return i18n('Listing Language');
    },
    type: 'array',
    options: I18N_LOCALES,
    optionTitles: LOCALE_NAMES,
  }) as const satisfies SearchFacetData;
